<template>
  <ul>
    <template v-if="el(href) === 'a'">
      <li class="nav-item single-link">
        <component
          :is="el(href)"
          :to="href"
          :href="href"
          class="nav-link"
          :target="target"
        >
          <slot />
        </component>
      </li>
    </template>
    <template v-else>
      <component
        :is="el(href)"
        :to="href"
        :href="href"
        :target="target"
      >
        <slot />
      </component>
    </template>
  </ul>
</template>
<script>

export default {
  name: 'generic-menu-link',
  props: {
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    },
    navType: {
      type: String,
      default: 'b-nav-item'
    }
  },
  methods: {
    el: function() {
      return (/^#|http(s)?:\/\//.test(this.href)) ? 'a' : this.navType
    }
  }
}
</script>
